The pagination metadata for this page of events.
